/* ==========================================================================
   MAIN TYPESCRIPT ENTRYPOINT (ts/main.ts)
   ========================================================================== */

import { initCanvasBackdrop } from './canvas-backdrop';
import { initMarqueeTicker } from './marquee';
import { initSandboxEngine } from './sandbox-engine';
import { initLandingView } from './views/landing';

document.addEventListener('DOMContentLoaded', () => {
  initLandingView();
  initSandboxEngine();
  initCanvasBackdrop('heroSection');
  initMarqueeTicker('shortcutMarquee');
});
